module.exports = "<svg id=\"triangle\" width=\"20\" height=\"20\" viewBox=\"-3 -4 39 39\">\n    <polygon fill=\"#D8D8C7\" stroke=\"#41403E\" stroke-width=\"1\" points=\"16,0 32,32 0,32\"></polygon>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/app/loader/loader.component.html
// module id = ./src/app/loader/loader.component.html
// module chunks = main